var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50033 10.0544C2.96895 10.0544 0.916992 8.0024 0.916992 5.47103C0.916992 2.93965 2.96895 0.887695 5.50033 0.887695C8.0317 0.887695 10.0837 2.93965 10.0837 5.47103C10.0837 8.0024 8.0317 10.0544 5.50033 10.0544ZM5.50033 9.1377C6.47279 9.1377 7.40542 8.75139 8.09305 8.06375C8.78068 7.37612 9.16699 6.44349 9.16699 5.47103C9.16699 4.49857 8.78068 3.56594 8.09305 2.8783C7.40542 2.19067 6.47279 1.80436 5.50033 1.80436C4.52787 1.80436 3.59523 2.19067 2.9076 2.8783C2.21997 3.56594 1.83366 4.49857 1.83366 5.47103C1.83366 6.44349 2.21997 7.37612 2.9076 8.06375C3.59523 8.75139 4.52787 9.1377 5.50033 9.1377ZM5.04199 3.17936H5.95866V4.09603H5.04199V3.17936ZM5.04199 5.0127H5.95866V7.7627H5.04199V5.0127Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicate);
export default __webpack_public_path__ + "static/media/indicate.eb57bd8115ab785cf98ad887fd6cdb6d.svg";
export { ForwardRef as ReactComponent };